var _defs, _path, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 266.8 285.9",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st0, .st1 {\n        stroke: #1d1d1b;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 8.5px;\n      }\n\n      .st1 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.2,11.4c-66.2,0-119.9,53.7-119.9,119.9s32.5,79.7,46,94.4c1.1.8,2.2,1.7,3.3,2.5h0l-8.7,32.3,36.6-17.2h0c13.3,5,27.8,7.9,42.9,7.9,66.2,0,119.9-53.7,119.9-119.9S203.5,11.4,137.2,11.4Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 69.9,
    y1: 105.5,
    x2: 204.5,
    y2: 105.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 69.9,
    y1: 134.5,
    x2: 191.6,
    y2: 134.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 69.9,
    y1: 163.5,
    x2: 161.8,
    y2: 163.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "chat.6ac0e2d83ba7f41df28da924a09af594.svg";